import {API_URL} from "../../../components/config/BaseUrl";

export const GET_WALLBOARD_QUEUES_URL = `${API_URL}/wificall/wallboard`;
